import type { CelebrationEvent } from "@/components/celebrations";

export type GamificationEvent = {
  type: string;
  points?: number;
  message?: string;
  achievementName?: string;
  achievementIcon?: string;
  levelName?: string;
  levelIcon?: string;
  skillName?: string;
};

export type GamificationResult = {
  pointsEarned: number;
  newTotalPoints: number;
  level: { level: number; name: string; icon: string };
  events: GamificationEvent[];
};

/**
 * Turns what the server awarded into things to celebrate on screen.
 *
 * Shared because a session can be completed from two places — the learner
 * finishing their own work, and a grown-up reviewing it — and the same
 * achievement should look the same either way.
 */
export function toCelebrationEvents(gamification: GamificationResult): CelebrationEvent[] {
  const events: CelebrationEvent[] = [];
  let index = 0;

  for (const event of gamification.events) {
    switch (event.type) {
      case "achievement":
        events.push({
          id: `achievement-${index++}`,
          type: "achievement",
          title: event.achievementName || "Pasiekimas",
          description: event.message,
          icon: event.achievementIcon,
          points: event.points,
        });
        break;
      case "level_up":
        events.push({
          id: `level-${index++}`,
          type: "level_up",
          title: `${event.levelIcon} Naujas lygis!`,
          description: `Pasiektas ${event.levelName}`,
          icon: event.levelIcon,
        });
        break;
      case "skill_mastered":
        events.push({
          id: `mastered-${index++}`,
          type: "skill_mastered",
          title: "Įgūdis įvaldytas!",
          description: event.skillName,
          icon: "🏅",
          points: event.points,
        });
        break;
      case "skill_unlocked":
        events.push({
          id: `unlock-${index++}`,
          type: "skill_unlocked",
          title: "Naujas įgūdis atrakintas!",
          description: event.skillName,
          icon: "🔓",
          points: event.points,
        });
        break;
      case "personal_best":
        events.push({
          id: `best-${index++}`,
          type: "personal_best",
          title: "Naujas rekordas!",
          description: event.skillName,
          icon: "🎯",
          points: event.points,
        });
        break;
    }
  }

  return events;
}
